"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssignOpActionPicker = void 0;
const DataType_1 = __importDefault(require("@opsbase/lib-datatype/DataType"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const WorkflowAction_1 = __importDefault(require("@opsbase/lib-workflow/WorkflowAction"));
const useCallforward_1 = __importDefault(require("@opsbase/react-hooks/useCallforward"));
const DataChooser_1 = __importDefault(require("@opsbase/web-data-choosers/DataChooser"));
const SPTChooser_1 = __importDefault(require("@opsbase/web-data-choosers/SPTChooser/SPTChooser"));
const Divider_1 = __importDefault(require("@opsbase/web-layout/Divider"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane/Pane"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const TimeDiffPicker_1 = require("@opsbase/web-op-scheduler/OpScheduleEditor/TimeDiffPicker");
const FieldSet_1 = __importDefault(require("@opsbase/web-ui/FieldSet/FieldSet"));
const Radio_1 = __importDefault(require("@opsbase/web-ui/Radio"));
const RadioGroup_1 = __importDefault(require("@opsbase/web-ui/RadioGroup"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const react_1 = __importStar(require("react"));
function AssignOpActionPicker(props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    const { action, onChangeAction, type, disabled = false } = props;
    const config = action === null || action === void 0 ? void 0 : action.workflowActionConfig;
    const [sel, setSel] = (0, react_1.useState)(((_a = config === null || config === void 0 ? void 0 : config.assignTo) === null || _a === void 0 ? void 0 : _a.allSelected) ? 'all' : (config === null || config === void 0 ? void 0 : config.assignToIssueCloser) ? 'issue-closer' : 'any');
    const isAny = sel === 'any';
    const isAll = sel === 'all';
    const isIssueCloser = sel === 'issue-closer';
    const whenCanStart = (config === null || config === void 0 ? void 0 : config.whenCanStart) || 60;
    const whenCanView = (config === null || config === void 0 ? void 0 : config.whenCanView) || 480;
    const due = (config === null || config === void 0 ? void 0 : config.due) || 60;
    const visibleInvalid = whenCanStart > whenCanView;
    const [spt, setSPT] = (0, react_1.useState)(([].concat((_c = (_b = config === null || config === void 0 ? void 0 : config.assignTo) === null || _b === void 0 ? void 0 : _b.team) === null || _c === void 0 ? void 0 : _c.map(t => (Object.assign(Object.assign({}, t), { __typename: DataType_1.default.TEAM })))) || [])
        .concat((_e = (_d = config === null || config === void 0 ? void 0 : config.assignTo) === null || _d === void 0 ? void 0 : _d.position) === null || _e === void 0 ? void 0 : _e.map(p => (Object.assign(Object.assign({}, p), { __typename: DataType_1.default.POSITION }))))
        .concat(((_g = (_f = config === null || config === void 0 ? void 0 : config.assignTo) === null || _f === void 0 ? void 0 : _f.staff) === null || _g === void 0 ? void 0 : _g.map(s => (Object.assign(Object.assign({}, s), { __typename: DataType_1.default.STAFF })))) || []));
    const handleChangeOpDefinition = (0, react_1.useCallback)(a => {
        var _a, _b;
        config.opDefinition = {
            id: (_a = a[0]) === null || _a === void 0 ? void 0 : _a.id,
            title: (_b = a[0]) === null || _b === void 0 ? void 0 : _b.title,
        };
        action.workflowActionConfig = config;
        onChangeAction(new WorkflowAction_1.default(action));
    }, [config, action, onChangeAction]);
    const handleChange = (0, useCallforward_1.default)(field => value => {
        config[field] = value;
        action.workflowActionConfig = config;
        onChangeAction(new WorkflowAction_1.default(action));
    }, [config, action, onChangeAction]);
    const handleSetSel = (0, react_1.useCallback)(value => {
        setSel(value);
        switch (value) {
            case 'all':
                config['assignTo'].allSelected = true;
                config['assignToIssueCloser'] = false;
                break;
            case 'any':
                config['assignTo'].allSelected = false;
                config['assignToIssueCloser'] = false;
                break;
            case 'issue-closer':
                config['assignToIssueCloser'] = true;
                break;
        }
        handleChange('assignTo')(config.assignTo);
        handleChange('assignToIssueCloser')(config.assignToIssueCloser);
    }, [handleChange, config]);
    const handleChangeSPT = (0, react_1.useCallback)(v => {
        setSPT(v);
        config.assignTo = Object.assign(Object.assign({}, config.assignTo), { team: v.filter(i => i.type === DataType_1.default.TEAM), allStaff: false, staff: v.filter(i => i.type === DataType_1.default.STAFF), position: v.filter(i => i.type === DataType_1.default.POSITION) });
        handleChange('assignTo')(config.assignTo);
    }, [handleChange, config]);
    const handleSelectAllStaff = (0, react_1.useCallback)(v => {
        config.assignTo = Object.assign(Object.assign({}, config.assignTo), { allStaff: v, staff: v ? [] : config.assignTo.staff });
        handleChange('assignTo')(config.assignTo);
    }, [handleChange, config]);
    const handleChangeDue = (0, react_1.useCallback)(v => {
        handleChange('due')(v);
    }, [handleChange]);
    const handleChangeStart = (0, react_1.useCallback)(v => {
        handleChange('whenCanStart')(v);
    }, [handleChange]);
    const handleChangeView = (0, react_1.useCallback)(v => {
        handleChange('whenCanView')(v);
    }, [handleChange]);
    return (react_1.default.createElement(Vertical_1.default, { gutter: true },
        react_1.default.createElement(Horizontal_1.default, { centered: true, gutter: true, justify: 'flex-start' },
            react_1.default.createElement(Text_1.default, { style: { minWidth: 100 } }, lib_i18n_1.default.t('op-plan')),
            react_1.default.createElement(Pane_1.default, { grow: true },
                react_1.default.createElement(DataChooser_1.default, { disabled: disabled, selectLabel: lib_i18n_1.default.t('select-op-plan'), value: ((_h = config === null || config === void 0 ? void 0 : config.opDefinition) === null || _h === void 0 ? void 0 : _h.id) ? [config === null || config === void 0 ? void 0 : config.opDefinition] : [], type: [DataType_1.default.OPDEFINITION], onChange: handleChangeOpDefinition }))),
        ((_j = config === null || config === void 0 ? void 0 : config.opDefinition) === null || _j === void 0 ? void 0 : _j.id) && (react_1.default.createElement(react_1.default.Fragment, null,
            ' ',
            react_1.default.createElement(Pane_1.default, { paddingY: true },
                react_1.default.createElement(FieldSet_1.default, { label: lib_i18n_1.default.t('assignto') },
                    react_1.default.createElement(RadioGroup_1.default, { value: sel, onChange: handleSetSel },
                        react_1.default.createElement(Vertical_1.default, null,
                            type === 'issue' && (react_1.default.createElement(Horizontal_1.default, { justify: "flex-start", gutter: true, centered: true },
                                react_1.default.createElement(Radio_1.default, { value: "issue-closer", checked: isIssueCloser }),
                                react_1.default.createElement(Text_1.default, { color: isIssueCloser && lib_palette_1.default.GoodOldBlue }, lib_i18n_1.default.t('issue-closer.long')))),
                            react_1.default.createElement(Horizontal_1.default, { justify: "flex-start", gutter: true, centered: true },
                                react_1.default.createElement(Radio_1.default, { value: "any", checked: isAny }),
                                react_1.default.createElement(Text_1.default, { color: isAny && lib_palette_1.default.GoodOldBlue }, lib_i18n_1.default.t('any-staff-selected'))),
                            isAny && (react_1.default.createElement(SPTChooser_1.default, { multi: true, value: spt, filters: {
                                    opDefinition: [(_k = config === null || config === void 0 ? void 0 : config.opDefinition) === null || _k === void 0 ? void 0 : _k.id],
                                    enabled: ['TRUE'],
                                }, onChange: handleChangeSPT })),
                            react_1.default.createElement(Horizontal_1.default, { justify: "flex-start", gutter: true, centered: true },
                                react_1.default.createElement(Radio_1.default, { value: "all", checked: isAll }),
                                react_1.default.createElement(Text_1.default, { color: isAll && lib_palette_1.default.GoodOldBlue }, lib_i18n_1.default.t('all-staff-selected'))),
                            isAll && (react_1.default.createElement(SPTChooser_1.default, { multi: true, value: spt, filters: {
                                    opDefinition: [(_l = config === null || config === void 0 ? void 0 : config.opDefinition) === null || _l === void 0 ? void 0 : _l.id],
                                    enabled: ['TRUE'],
                                }, onChange: handleChangeSPT, allSelectedLabel: lib_i18n_1.default.t('all-staff'), allSelectable: true, allSelected: config === null || config === void 0 ? void 0 : config.assignTo.allStaff, onSelectAll: handleSelectAllStaff })))))),
            react_1.default.createElement(Divider_1.default, null),
            react_1.default.createElement(Pane_1.default, null,
                react_1.default.createElement("ul", null,
                    react_1.default.createElement("li", null,
                        react_1.default.createElement(Text_1.default, null,
                            lib_i18n_1.default.t('due') + ' ',
                            react_1.default.createElement(TimeDiffPicker_1.TimeDiffPicker, { noMargin: true, noBorder: true, value: due, onChange: handleChangeDue }),
                            ' ',
                            lib_i18n_1.default.t('after-the-trigger'))),
                    react_1.default.createElement("li", null,
                        react_1.default.createElement(Text_1.default, null,
                            lib_i18n_1.default.t('can-be-started') + ' ',
                            react_1.default.createElement(TimeDiffPicker_1.TimeDiffPicker, { noMargin: true, noBorder: true, value: whenCanStart, onChange: handleChangeStart }),
                            ' ',
                            lib_i18n_1.default.t('before-due'))),
                    react_1.default.createElement("li", null,
                        react_1.default.createElement(Text_1.default, { color: visibleInvalid ? 'error' : undefined },
                            lib_i18n_1.default.t('visible-in-todo') + ' ',
                            react_1.default.createElement(TimeDiffPicker_1.TimeDiffPicker, { noMargin: true, noBorder: true, value: whenCanView, onChange: handleChangeView }),
                            ' ',
                            lib_i18n_1.default.t('before-due')))))))));
}
exports.AssignOpActionPicker = AssignOpActionPicker;
exports.default = AssignOpActionPicker;
